const SouthBrisbaneMap = ({ className = 'h-80 w-full border-0 md:h-96' }) => {
  const mapSrc = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d906978.0193476999!2d152.333676600791!3d-27.37937264328613!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xcd4b97ba967362f%3A0xd7d10cd76d153000!2sThe%20Skilled%20Group!5e0!3m2!1sen!2snp!4v1783433910239!5m2!1sen!2snp';
  return (
    <div>
      <iframe
        title="Brisbane Google Map"
        src={mapSrc}
        className={className}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  );
};

export default SouthBrisbaneMap;